import React from 'react';
import styled from 'styled-components';
import Typography from './Typography';
import CloseIcon from './Icons/CloseIcon';
import { theme } from '../theme';

const FilterChip = ({
  category,
  isActive = true,
  onRemove,
  icon,
  iconSize = '24px'
}) => {
  return (
    <Option $isActive={isActive} onClick={onRemove}>
      {icon && <StyledIcon $size={iconSize}>{icon}</StyledIcon>}
      <CategoryTitle
        as="p"
        $isActive={isActive}
        $variant="body-2-semibold"
        color={theme.colors.defaultMain}
      >
        {category}
      </CategoryTitle>
      {/* <CloseButton onClick={onRemove}>
        <CloseIcon fill={isActive ? theme.colors.defaultWeak : '#6B7280'} />
      </CloseButton> */}
      <CloseIcon fill={theme.colors.defaultWeak} />
    </Option>
  );
};

export default FilterChip;

const Option = styled.div`
  // border: 1px solid ${({ $isActive, theme }) => ($isActive ? theme.border.brandMain : theme.border.defaultWeak)};
  border: none;
  border-radius: ${({ theme }) => theme.sizing.lg};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: ${({ theme }) => theme.sizing.xxs};
  // padding: ${({ theme }) => theme.sizing.xs} ${({ theme }) => theme.sizing.sm};
  // background-color: ${({ $isActive, theme }) => ($isActive ? theme.fill.brandAlphaMain16 : theme.fill.defaultWeak)};
  background-color: ${({ theme }) => theme.fill.defaultWeak};
  transition: all 0.3s;
  height: 32px;
  padding-left: 12px;
  padding-right: ${({ theme }) => theme.sizing.xs};
  cursor: pointer;

  &:hover {
    // background-color: ${({ $isActive, theme }) => ($isActive ? theme.fill.brandAlphaMain24 : theme.fill.defaultSubtle)};
    background-color: ${({ theme }) => theme.fill.defaultStrong};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.sizing.xxs} 12px;
  }
`;

const CategoryTitle = styled(Typography)`
  // color: ${({ $isActive, theme }) => ($isActive ? theme.colors.brandMain : theme.colors.defaultSubtle)};
  flex: 1;
`;

const StyledIcon = styled.span`
  width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};

  svg {
    width: ${({ $size }) => $size};
    height: ${({ $size }) => $size};
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;